import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getAllPaymodes = async ({ companyCode }) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetPaymodes}?CompanyCode=${companyCode}`
  );
  return data;
};

export const useGetAllPaymodeQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetPaymodes],
    queryFn: () => getAllPaymodes(companyCode),
  });
};
